<template>
    <b-row class="address-input">
        <b-col :cols="12">
            <div class="mb-0">
                <b-row>
                    <b-col :cols="2">
                        <b-form-group :class="{filled: addressData.countryId}" class="smooth-form-group">
                            <LanogaSelect v-model="addressData.country"
                                          :options="countrySelectOptions"
                                          :externalOptionList="countries"
                                          :required="required"
                                          @select="selectCountry"
                                          :readonly="readOnly">
                            </LanogaSelect>
                            <label v-if="required" class="smooth-label required">Ország</label>
                            <label v-else class="smooth-label">Ország</label>
                        </b-form-group>
                    </b-col> 
                    <b-col :cols="2">
                        <b-form-group :class="{filled: addressData.cityId || addressData.city ? addressData.city.zip: null }" class="smooth-form-group" v-b-popover.hover.top="'Keresés irányítószámra vagy városra'">
                            <LanogaSelect v-model="addressData.city"
                                          :options="zipSelectOptions"
                                          :externalOptionList="addressData.countryId == 97 ? cities97 : cities"
                                          :additionalApiCallbackParams="zipAdditionalApiCallbackParams"
                                          :required="required"
                                          @select="selectZip"
                                          @cleared="resetAddressData"
                                          :readonly="readOnly">
                            </LanogaSelect>
                            <label v-if="required" class="smooth-label required">Irányítószám</label>
                            <label v-else class="smooth-label">Irányítószám</label>
                        </b-form-group>
                    </b-col>
                    <b-col v-if="addressData.county" :cols="2">
                        <b-form-group :class="{filled: addressData.county.region}" class="smooth-form-group">
                            <b-form-input :disabled="true" v-model="addressData.county.region"/>
                            <label class="smooth-label">Régió</label>
                        </b-form-group>
                    </b-col>
                    <b-col :cols="2">
                        <b-form-group :class="{filled: addressData.city ? addressData.city.name : null }" class="smooth-form-group">
                            <b-form-input :disabled="true" v-model="addressData.city.name" :readOnly="readOnly"/>
                            <label class="smooth-label">Város</label>
                        </b-form-group>
                    </b-col>
                    <b-col :cols="3">
                        <b-form-group :class="{filled: addressData.street}" class="smooth-form-group">
                            <b-form-input v-model="addressData.street" :required="required" :readOnly="readOnly"/>
                            <label v-if="required" class="smooth-label required">Utca</label>
                            <label v-else class="smooth-label">Utca</label>
                        </b-form-group>
                    </b-col>
                    <b-col :cols="1">
                        <b-form-group :class="{filled: addressData.streetNumber}" class="smooth-form-group">
                            <b-form-input v-model="addressData.streetNumber" :required="required" :readOnly="readOnly"/>
                            <label v-if="required" class="smooth-label required" >Házszám</label>
                            <label v-else class="smooth-label">Házszám</label>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
        </b-col>
    </b-row>
</template>

<script>
    import Api from "../util/Api";
    import LanogaSelect from "./LanogaSelect";
    import cities97 from '@/assets/codeStores/cityZips97.json';
    import countries from '@/assets/codeStores/countries.json';

    export default {
        name: "AddressInput",
        components: {LanogaSelect},
        props: {
            value: {type: Object},
            data: {type: Object},
            readOnly: {type: Boolean, default: false},
            required: { type: Boolean, default: true }
        },
        data() {
            return {
                cities97, 
                countries,
                cities: [],
                addressData: {},
                initLoad: true,
                inputOptions: {
                    city: {
                        name: "city",
                        label: "Település",
                        filter: {
                            type: "simple",
                        },
                        sort: true,
                        visibility: false,
                        formRequired: true,
                        formType: "text",
                        formReadOnly: true,
                        formSize: 3,
                        formVisible: true
                    },
                    street: {
                        name: "street",
                        label: "Utca",
                        filter: {
                            type: "simple",
                        },
                        sort: true,
                        visibility: false,
                        formRequired: true,
                        formType: "text",
                        formSize: 2,
                        formVisible: true
                    },
                    streetNumber: {
                        name: "streetNumber",
                        label: "Házszám",
                        filter: {
                            type: "simple",
                        },
                        sort: true,
                        visibility: false,
                        formRequired: true,
                        formType: "text",
                        formSize: 1,
                        formVisible: true
                    }
                }
            }
        },
        created() {
            this.addressData = {
                id: null,
                countryId: 97,
                countyId: null,
                zip: null,
                cityId: null,
                street: null,
                streetNumber: null,
                createdBy: null,
                modifiedBy: null,
                createdOn: null,
                modifiedOn: null,
                country: {
                    flag: null,
                    id: 97,
                    name: 'Magyarország'
                },
                county: {},
                city: {
                    zip: null,
                    name: "",
                },
                ...this.value
            };
            if(!this.addressData.city){
                this.addressData.city = {
                    zip: null,
                    name: "",
                }
            }
        },
        watch: {
            addressData: {
                handler(val) {
                    this.$emit('input', val);
                },
                deep: true
            },
            value: {
                handler(val) {
                    this.addressData = Object.assign(this.addressData, val);
                    if(!this.addressData.city){
                        this.addressData.city = {
                            zip: null,
                            name: "",
                        }
                    }
                    this.initRegionSelect()
                },
                deep: true
            },
            'addressData.city.zip'(newVal, oldVal) {
                if (newVal !== oldVal && newVal != undefined) {
                    if(this.addressData.countryId !==97){
                        Api.getCitiesByCountryIdZipName({ params: { countryId: this.addressData.countryId }}).then(({ data }) => {
                            let selectedItem = null
                            if(this.addressData.city.id){
                                selectedItem = data.find(item => item.id === this.addressData.city.id)
                            }else {
                                selectedItem = data.find(item => item.zip === this.addressData.city.zip)
                            }
                            this.selectZip(selectedItem)
                            this.initLoad = false
                        }).catch(() => {
                            this.initLoad = false
                        })
                    }else {
                        let selectedItem = null
                        if (this.addressData.city.id) {
                            selectedItem = cities97.find(item => item.id === this.addressData.city.id)
                        } else {
                            selectedItem = cities97.find(item => item.zip === this.addressData.city.zip)
                        }
                        this.selectZip(selectedItem)
                        this.initLoad = false
                    }
                }   
            },
            'addressData.countryId': {
                immediate: true,
                handler(newVal, oldVal) {
                    if (newVal === oldVal && newVal != undefined) {
                         if (newVal !== 97) {
                            Api.getCitiesByCountryIdZipName({params: { countryId: newVal }}).then(({ data }) => {
                                this.cities = data
                            }).catch(err => {
                                console.error(err)
                                this.cities = []
                            })
                        } else {
                            this.cities = []
                        }
                        return
                    }else {
                         if (newVal !== 97 && newVal != undefined) {
                            Api.getCitiesByCountryIdZipName({params: { countryId: newVal }}).then(({ data }) => {
                                this.cities = data
                            }).catch(err => {
                                console.error(err)
                                this.cities = []
                            })
                        } else {
                            this.cities = []
                        }
                        this.initLoad = false
                    }
                }
            },
        },
        methods: {
            resetAddressData() {
                this.addressData = {
                    id: null,
                    countryId: 97,
                    countyId: null,
                    zip: null,
                    cityId: null,
                    street: null,
                    streetNumber: null,
                    createdBy: null,
                    modifiedBy: null,
                    createdOn: null,
                    modifiedOn: null,
                    country: {
                        flag: null,
                        id: 97,
                        name: 'Magyarország'
                    },
                    county: {},
                    city: {
                        zip: null,
                        name: "",
                    },
                };
            },
            selectCountry(val) {
                this.addressData.countryId = val.id;
                this.addressData.country = {
                    id: val.id,
                    name: val.name,
                    flagUrl: val.flag
                };
            },
            selectZip(val) {
                if(!val || val === null || val === undefined){
                    return;
                }
                this.addressData.cityId = val.id;
                this.addressData.zip = val.zip;
                this.addressData.city = {
                    id: val.id,
                    zip: val.zip,
                    name: val.name,
                    countryId: val.country_id,
                    countyId: val.county_id
                };

                Api.getCountyById(val.county_id).then((response) => {
                    this.addressData.county = response.data;
                    this.addressData.countyId = response.data.id;
                }).catch((err) => {
                    console.error(err);
                    this.addressData.county = {};
                });
            },
            initRegionSelect() {
                if (this.initLoad && this.addressData.city && this.addressData.city.zip) {
                    if(this.addressData.countryId !==97){
                        Api.getCitiesByCountryIdZipName({ params: { countryId: this.addressData.countryId }})
                        .then(({ data }) => {
                            let selectedItem = null
                            if(this.addressData.city.id){
                                selectedItem = data.find(item => item.id === this.addressData.city.id)
                            }else {
                                selectedItem = data.find(item => item.zip === this.addressData.city.zip)
                            }
                            this.selectZip(selectedItem)
                            this.initLoad = false
                        })
                        .catch(() => {
                            this.initLoad = false
                        })
                    }else {
                        let selectedItem = null
                        if (this.addressData.city.id) {
                            selectedItem = cities97.find(item => item.id === this.addressData.city.id)
                        } else {
                            selectedItem = cities97.find(item => item.zip === this.addressData.city.zip)
                        }
                        this.selectZip(selectedItem)
                        this.initLoad = false
                    }
                }
            }
        },
        computed: {
            zipAdditionalApiCallbackParams() {
                return {
                    countryId: this.addressData.countryId
                }
            },
            zipSelectOptions() {
                return {
                    searchOnServer: false,
                    filteredAttr: 'text',
                    formatText: val => val?.zip || '',
                    formatOption: val => val?.text || '',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            countrySelectOptions() {
                return {
                    formatText: val => val?.name || '',
                    formatOption: val => val?.name || '',
                    minimumInputLength: 1,
                    searchOnServer: false,
                    filteredAttr: 'name',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            }
        },
    }
</script>
<style scoped>
    .address-input {
        margin-bottom: 1rem;
    }
</style>
